import { render } from "./StudiesDropdown.vue?vue&type=template&id=0a4242f9&scoped=true"
import script from "./StudiesDropdown.vue?vue&type=script&lang=js"
export * from "./StudiesDropdown.vue?vue&type=script&lang=js"

import "./StudiesDropdown.vue?vue&type=style&index=0&id=0a4242f9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4242f9"]])

export default __exports__